import { NotFoundError } from '../../../../errors/not-found-error';
import { LinkedEpisodeRecording, Recording, SeriesRecording, SingleRecording } from '../types/recording';

export function getSingleRecordingBy<T>(recordings: Recording[], value: T, selector: (value: SingleRecording) => T) {
  if (recordings.length === 0) {
    return undefined;
  }

  for (const recording of recordings) {
    if (recording.type === 'series') {
      const episode = recording.episodes.find((ep) => selector(ep) === value);

      if (episode) {
        return episode;
      }
    } else if (selector(recording) === value) {
      return recording;
    }
  }
}

/**
 * Finds a series recording based on a linked episode recording.
 *
 * @param episode The linked episode recording.
 * @param recordings The list of recordings.
 * @returns The series recording.
 * @throws {NotFoundError} If the series recording is not found.
 */
export function findRecordingSeries(episode: LinkedEpisodeRecording, recordings: Recording[]): SeriesRecording {
  const series = recordings.find(
    (rec): rec is SeriesRecording => rec.type === 'series' && rec.periodicTaskId === episode.periodicTaskId,
  );

  if (series === undefined) {
    throw new NotFoundError('Series not found');
  }

  return series;
}
